import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "@/redux/store";

const selectFilterOption = (state: RootState) =>
  state.extractFlightFilter.selectOption;

const selectFilterDefault = (state: RootState) =>
  state.extractFlightFilter.defaultOption;

const selectSearchEnd = (state: RootState) =>
  state.flightSearchStatus.isResponseEnd;

const selectSearchError = (state: RootState) =>
  state.flightSearchStatus.error;

export const selectFilterOptions = createSelector(
  [selectFilterOption, selectFilterDefault],
  (selectOption, defaultOption) => ({ selectOption, defaultOption }),
);

export const selectSearchStatus = createSelector(
  [selectSearchEnd, selectSearchError],
  (isResponseEnd, error) => ({ isResponseEnd, error }),
);
